export default __webpack_public_path__ + "static/media/toast-add-success.18a9ac19.svg";